










import { DOG, CAT, MIX, ACTIVE } from '@front/common/constants'
import { Pet } from '@front/common/types'
import { defineComponent, toRefs, PropType } from 'vue-demi'

export default defineComponent({
  props: {
    petType: {
      type: String,
      default: null,
    },
    pets: {
      type: Array as PropType<Pet[]>,
      default: null,
    },
  },
  setup(props, { slots }) {
    const { petType, pets } = toRefs(props)

    const BANNER_OPTIONS = {
      [MIX]: 'mix',
      [CAT]: 'cat',
      [DOG]: 'dog',
    }

    function bannerSelector(slotName: string) {
      if (petType.value) {
        return (
          ((slots[BANNER_OPTIONS[petType.value]] &&
            BANNER_OPTIONS[petType.value]) ||
            MIX) === slotName
        )
      }

      const activePets = pets.value.filter(({ status }) => {
        return status === ACTIVE
      })
      let hasCat = false
      let hasDog = false

      activePets.forEach((pet) => {
        if (pet.species === CAT) {
          hasCat = true
        }
        if (pet.species === DOG) {
          hasDog = true
        }
      })

      if (hasCat && slots.cat) {
        return CAT === slotName
      }

      if (hasDog && slots.dog) {
        return DOG === slotName
      }

      return MIX === slotName
    }

    return { CAT, DOG, MIX, bannerSelector }
  },
})
